import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-home',
  imports: [RouterLink],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class Home implements OnInit, OnDestroy {
  isScrolled = false;
  activeServicio = 0;

  private observer!: IntersectionObserver;

  @HostListener('window:scroll')
  onScroll(): void {
    this.isScrolled = window.scrollY > 20;
  }

  ngOnInit(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            this.observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 },
    );

    // Slight delay to let Angular render the template
    setTimeout(() => {
      document.querySelectorAll('.reveal').forEach((el) => this.observer.observe(el));
    }, 0);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  setActiveServicio(index: number): void {
    this.activeServicio = index;
  }
}
